import styled from 'styled-components';
import { Filter } from '@styled-icons/heroicons-solid';
import { Close } from '@styled-icons/evaicons-solid/';

export { ButtonMini, Button, Loading } from '../../../styles/components';

export const Container = styled.div`
  display: flex;
  column-gap: 16px;
`;

export const ButtonFilter = styled.button.attrs({ type: 'button' })`
  &:hover {
    svg {
      fill: ${({ theme }) => theme.colors.lightDarkBlue};
      stroke-width: 0;
    }
  }
`;

export const IconFilter = styled(Filter).attrs({ size: 24 })`
  fill: transparent;
  stroke: ${({ theme }) => theme.colors.lightDarkBlue};
  stroke-width: 1pt;
`;

export const IconFilterButton = styled(Filter).attrs({ size: 24 })`
  fill: ${({ active, theme }) =>
    active ? theme.colors.lightDarkBlue : 'transparent'};
  stroke: ${({ theme }) => theme.colors.lightDarkBlue};
  stroke-width: 1pt;
`;

export const IconFilterModal = styled(Filter).attrs({ size: 24 })`
  color: ${({ theme }) => theme.colors.black};
  margin-right: 8px;
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: ${({ open }) => (open ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  overflow: auto;
`;

export const Box = styled.div`
  display: flex;
  width: 100%;
  max-width: 800px;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 6px;
  padding: 40px;
  animation-name: appear;
  animation-duration: 200ms;
  animation-timing-function: ease-in;
  animation-direction: alternate;

  input {
    &[type='time']::-webkit-inner-spin-button {
      display: none;
    }
  }
  input {
    &[type='time']::-webkit-calendar-picker-indicator {
      display: none;
    }
  }

  @keyframes appear {
    0% {
      transform: scale(0.5);
    }
    100% {
      transform: scale(1);
    }
  }
`;

export const Head = styled.div`
  width: 100%;
  padding-bottom: 24px;
  margin-bottom: 24px;
  border-bottom: 1px ${({ theme }) => theme.colors.line} solid;
`;

export const Title = styled.h1`
  display: flex;
  align-items: center;
  font-size: 20px;
  color: ${({ theme }) => theme.colors.black};
`;

export const WrapFilters = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 4%;
  width: 100%;
  align-items: center;
`;

export const WrapInputs = styled.div`
  display: flex;
  margin-top: 5%;
  margin-bottom: 16px;
`;

export const WrapButtons = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
  margin-top: 24px;
  border-left: none;
  border-right: none;

  button:first-child {
    margin-right: 16px;
  }
`;

export const IconClose = styled(Close).attrs({ size: 20 })`
  margin-left: 8px;
`;
